import { useState, useRef, useEffect } from 'react'
import { useAuth } from '../../context/AuthContext'
import { useConfig } from '../../context/ConfigContext'
import { useSync } from '../../context/SyncContext'

function SyncDot() {
  const { estado, tienePlanSync } = useSync()
  if (!tienePlanSync) return null

  const estilos = {
    conectando: 'bg-yellow-400 animate-pulse',
    activo: 'bg-tienda-success',
    pausado: 'bg-tienda-success opacity-50',
    error: 'bg-tienda-danger',
    inactivo: 'bg-tienda-muted opacity-40',
  }

  const labels = {
    conectando: 'Sincronizando...',
    activo: 'Sync activo',
    pausado: 'Sync en pausa',
    error: 'Error de sync',
    inactivo: 'Sync inactivo',
  }

  return (
    <div
      title={labels[estado] ?? estado}
      className={`w-2 h-2 rounded-full flex-shrink-0 ${estilos[estado] ?? 'bg-tienda-muted'}`}
    />
  )
}

export default function TopBar() {
  const { usuario, logout } = useAuth()
  const { config } = useConfig()
  const [abierto, setAbierto] = useState(false)
  const menuRef = useRef(null)

  useEffect(() => {
    function handleClick(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setAbierto(false)
      }
    }
    if (abierto) document.addEventListener('mousedown', handleClick)
    return () => document.removeEventListener('mousedown', handleClick)
  }, [abierto])

  if (!usuario) return null

  const esAdmin = usuario.rol === 'admin'
  const inicial = usuario.nombre[0].toUpperCase()

  return (
    <div className="fixed top-0 left-0 right-0 z-40 bg-tienda-surface border-b border-tienda-border">
      <div className="px-4 h-12 flex items-center justify-between">

        {/* Izquierda: ícono + nombre + versión */}
        <div className="flex items-center gap-2 min-w-0">
          <span className="text-lg flex-shrink-0" aria-hidden="true">🛒</span>
          <div className="min-w-0">
            <span className="block font-bold text-tienda-text text-sm leading-tight truncate">
              {config.nombreTienda}
            </span>
            <span className="block text-tienda-muted text-[10px] leading-tight select-none">
              v{__APP_VERSION__}
            </span>
          </div>
        </div>

        {/* Derecha: sync dot + menú usuario */}
        <div className="flex items-center gap-2 flex-shrink-0">
          <SyncDot />
          <div className="relative" ref={menuRef}>
            <button
              onClick={() => setAbierto(v => !v)}
              className="flex items-center gap-2 bg-tienda-bg border border-tienda-border rounded-xl px-2.5 py-1.5 active:scale-95 transition-transform"
            >
              <div className={`w-6 h-6 rounded-lg flex items-center justify-center text-xs font-bold text-gray-900
                ${esAdmin ? 'bg-tienda-accent' : 'bg-tienda-success'}`}>
                {inicial}
              </div>
              <span className="text-tienda-text text-sm font-semibold">{usuario.nombre}</span>
              <svg
                className={`w-3.5 h-3.5 text-tienda-muted transition-transform ${abierto ? 'rotate-180' : ''}`}
                viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"
                aria-hidden="true"
              >
                <path d="M6 9l6 6 6-6" />
              </svg>
            </button>

            {abierto && (
              <div className="absolute right-0 top-full mt-2 w-48 bg-tienda-surface border border-tienda-border rounded-2xl shadow-lg overflow-hidden z-50">
                <div className="px-4 py-3 border-b border-tienda-border">
                  <p className="text-tienda-text text-sm font-semibold">{usuario.nombre}</p>
                  <p className="text-tienda-muted text-xs capitalize">
                    {esAdmin ? 'Administrador' : 'Ventas'}
                  </p>
                </div>
                <button
                  onClick={() => { setAbierto(false); logout() }}
                  className="w-full flex items-center gap-3 px-4 py-3 text-tienda-danger text-sm font-semibold active:bg-tienda-danger/10"
                >
                  <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                    <polyline points="16 17 21 12 16 7" />
                    <line x1="21" y1="12" x2="9" y2="12" />
                  </svg>
                  Cerrar sesión
                </button>
              </div>
            )}
          </div>
        </div>

      </div>
    </div>
  )
}
